import React, { Component } from 'react';
import {
BrowserRouter,
Router,
Route,
Link,
Switch
} from 'react-router-dom'
import './App.css';
import AppLock from './Privacy Policy/AppLock/index.js'
import SleepTimer from './Privacy Policy/SleepTimer/index.js'
import SecurePass from './Privacy Policy/SecurePass/index.js'

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" render={ ( ) => (<h2> HomePage </h2>) } />
          <Route path="/apps/applock/privacy-policy" render={ ( ) => <AppLock /> }/>
		      <Route path="/apps/sleep-timer/privacy-policy" render={ ( ) => <SleepTimer /> }/>
          <Route path="/apps/secure-pass/privacy-policy" render={ ( ) => <SecurePass /> }/>
          <Route path="*" render={ ( ) => (<center><h2> NOT FOUND<br/> Error 404 </h2></center>) }/>
        </Switch>
       </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js